import { useGetAuthData } from 'src/hooks/use-get-auth-data';
import { useMutation, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'src/constants/queryKeys';
import { getMarketplaceTiles, putMarketplaceTiles } from 'src/api/marketplace';
import { IMarketplace } from 'src/components/profileComponents/Marketplace/types';
import { IMarketplaceComplexTileConfig } from 'src/typings/marketplace';
import { queryClient } from 'src/lib/queryClient';

export const useMarketplaceTile = (marketplace: IMarketplace | undefined) => {
  const { getJWT } = useGetAuthData();
  const jwt = getJWT();

  const {
    data: tilesConfig, isLoading: tilesConfigLoading, error: tilesConfigError, refetch,
  } = useQuery({
    queryKey: [QUERY_KEYS.TILE],
    queryFn: async () => {
      if (!marketplace) return undefined;
      const data = await getMarketplaceTiles(jwt, `?module.frontConfiguration.marketplace=${marketplace.id}`);
      return data.data['hydra:member'][0];
    },
    enabled: !!jwt && !!marketplace,
  });

  const saveTilesConfig = useMutation({
    mutationFn: (data: {dataToSave: IMarketplaceComplexTileConfig}) => putMarketplaceTiles.bind(this, jwt, `/${data.dataToSave.id}`, data.dataToSave)(),
    onSuccess: (data) => {
      queryClient.setQueryData([QUERY_KEYS.TILE, { id: marketplace?.id }], data);
    },
  });

  return {
    refetch,
    saveTilesConfig,
    tilesConfig,
    tilesConfigLoading,
    tilesConfigError,
  };
};
